export enum LifeCycleEdit { 
  Unknown = 0, 
  Created = 1,
  Modified = 2,
  Deleted = 3,
  Initialized = 4,
}
